import { createContext, useContext } from "react";

export const DestinationContext = createContext({
  destinations: [],
  setDestinations: () => {},
});
export const useDestinationContext = () => useContext(DestinationContext);
